import { useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { notifyNitroPayNavigation } from './nitroPay';

/**
 * Signals NitroPay on real route changes. Mount once, in the router layout.
 *
 * Keyed on pathname, not the full location: deep-link tabs and chip filters
 * rewrite the hash on every click, and letting NitroPay see those as
 * navigations stacked a new ad unit per click (see nitroPay.js). Skips the
 * initial mount — each slot's createAd is its first page view.
 *
 * Must be a LAYOUT effect. `nitroAds.navigate()` calls `onNavigate()` on every
 * placement it tracks, which clears and re-renders it. A placement that mounts
 * in the same commit as the route change (e.g. swiping back to the
 * leaderboard, whose <NitroAd> renders immediately) calls createAd from its
 * passive effect; if navigate() ran after that, it would start a second render
 * of the still-initializing ad and the slot would show two creatives. Layout
 * effects all run before any passive effect in a commit, so navigate() only
 * ever refreshes placements that survived the route change.
 */
export function useNitroPayNavigation() {
    const { pathname } = useLocation();
    const prevPathname = useRef(pathname);
    useLayoutEffect(() => {
        if (prevPathname.current === pathname) return;
        prevPathname.current = pathname;
        notifyNitroPayNavigation();
    }, [pathname]);
}
